export default class EventBus {
    constructor() {
        this._callbacks = new WeakMap();

        // Fallback to TinyEmitter when EventTarget isn't available
        try {
            this._t = new EventTarget();
        } catch (e) {
            this.e = {};
        }
    }

    // Use TinyEmitter's approach when EventTarget isn't available
    _emitTinyEmitter(name, ...args) {
        const evtArr = (this.e[name] || []).slice();
        for (let i = 0, len = evtArr.length; i < len; i++) {
            evtArr[i].fn.apply(evtArr[i].ctx, args);
        }
    }

    on(name, callback, ctx) {
        if (this._t) {
            const wrappedCallback = (e) => callback.apply(null, e._p);
            this._callbacks.set(callback, wrappedCallback);
            this._t.addEventListener(name, wrappedCallback, ctx);
        } else {
            (this.e[name] || (this.e[name] = [])).push({
                fn: callback,
                ctx: ctx
            });
        }
    }

    off(name, callback) {
        if (this._t) {
            const wrappedCallback = this._callbacks.get(callback);
            if (wrappedCallback) {
                this._t.removeEventListener(name, wrappedCallback);
                this._callbacks.delete(callback);
            }
        } else {
            const evts = this.e[name];
            const liveEvents = [];
            if (evts) {
                for (let i = 0, len = evts.length; i < len; i++) {
                    if (evts[i].fn !== callback && evts[i].fn._ !== callback) {
                        liveEvents.push(evts[i]);
                    }
                }
            }
            if (liveEvents.length) {
                this.e[name] = liveEvents;
            } else {
                delete this.e[name];
            }
        }
    }

    emit(name, ...args) {
        if (this._t) {
            const e = new Event(name);
            e._p = args;
            this._t.dispatchEvent(e);
        } else {
            this._emitTinyEmitter(name, ...args);
        }
    }

    once(name, callback, ctx) {
        const self = this;
        const onceListener = function (...args) {
            self.off(name, onceListener);
            callback.apply(ctx, args);
        };
        this.on(name, onceListener, { once: true });
    }
}

// import { ref, provide, inject } from 'vue';

// // Create a new instance of an event bus
// const eventBusSymbol = Symbol();

// export function createEventBus() {
//     const bus = {
//         emit(event, ...args) {
//             const handlers = bus[event];
//             if (handlers) {
//                 for (const handler of handlers) {
//                     if (typeof handler === 'function') {
//                         handler(...args);
//                     } else {
//                         console.warn(handler);
//                         console.warn('Invalid handler detected for event:', event);
//                     }
//                 }
//             }
//         },
//         on(event, handler) {
//             if (!bus[event]) {
//                 bus[event] = [];
//             }
//             bus[event].push(handler);
//         },
//         off(event, handler) {
//             if (bus[event]) {
//                 const index = bus[event].indexOf(handler);
//                 if (index !== -1) {
//                     bus[event].splice(index, 1);
//                 }
//             }
//         },
//     };

//     return bus;
// }

// export function provideEventBus(app) {
//     app.provide(eventBusSymbol, createEventBus());
// }

// export function useEventBus() {
//     const bus = inject(eventBusSymbol);
//     if (!bus) {
//         throw new Error('Event bus not provided.');
//     }
//     return bus;
// }
